<script setup lang="ts">
// TODO: きちんとTS化する
import {
  KkLoading
} from '../../../components/base'
import { onBeforeUnmount, watch, computed, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'

type Suggest = {
  [idKey: string]: string | number
  value: string
}

interface Props {
  id: string | number
  value: string
  idKey?: string
  placeholder?: string
  suggests?: Suggest[]
  currentSuggest?: Suggest
  disabled?: boolean
  isLoading?: boolean
}

const emit = defineEmits(['input', 'input-field', 'focus-field', 'select-suggest', 'close-suggest'])
const { t } = useI18n()
const props = withDefaults(defineProps<Props>(), {
  idKey: 'id',
  placeholder: '',
  suggests: () => [],
  isLoading: false,
  disabled: false,
})
const state = reactive({
  isSuggest: false,
})
const suggestRef = ref<null | Node>(null)

onBeforeUnmount(() => {
  window.removeEventListener('click', closeSuggest)
})

const modelValue = computed({
  get: () => props.value,
  set: newValue => {
    emit('input', newValue)
    emit('input-field', { value: newValue, id: props.id })
  }
})

const openSuggest = (suggest: unknown) => {
  state.isSuggest = true
  emit('focus-field', suggest)
}
const selectSuggest = (suggest: unknown) => {
  state.isSuggest = false
  emit('select-suggest', { suggest, id: props.id })
}
const closeSuggest = (event: MouseEvent) => {
  const target = event.target as Node
  if (suggestRef.value && target && !suggestRef.value.contains(target)) {
    state.isSuggest = false
    emit('close-suggest', props.id)
  }
}

watch(() => state.isSuggest, (newValue) => {
  if (newValue) {
    window.addEventListener('click', closeSuggest)
  } else {
    window.removeEventListener('click', closeSuggest)
  }
})
</script>

<template>
  <div ref="suggestRef" class="suggestField">
    <input
      v-model="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @focus="openSuggest(value)"
    >
    <div v-if="state.isSuggest" class="suggestField__container">
      <KkLoading v-if="isLoading" min-height="160px" />
      <div v-else-if="suggests.length" class="suggestField__items">
        <button
          v-for="suggest in suggests"
          :key="suggest[idKey]"
          type="button"
          :class="{ 'is-current': currentSuggest && suggest[idKey] === currentSuggest[idKey] }"
          @click.stop="selectSuggest(suggest)"
        >
          <slot name="suggest" :item="suggest" />
        </button>
      </div>
      <p v-else class="suggestField__noItem">{{ t('components.SuggestField.noItem') }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.suggestField {
  display: block;
  position: relative;
  input {
    display: block;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    background-color: #FFF;
    font-size: 14px;
    line-height: 1.5;
  }
  &__container {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
    min-width: 100%;
    max-height: 480px;
    padding: 8px 0;
    border-radius: 4px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .05);
    overflow-x: auto;
    background: #FFF;
    white-space: nowrap;
  }
  &__items {
    button {
      display: block;
      width: 100%;
      padding: 12px 24px;
      text-align: left;
      transition: .2s;
      &:hover,
      &.is-current {
        background-color: #E5E5E5;
      }
    }
  }
  &__noItem {
    padding: 8px 16px;
  }
}
</style>
